import { render } from "./DetailData.vue?vue&type=template&id=be4a5f5c&scoped=true"
import script from "./DetailData.vue?vue&type=script&lang=js"
export * from "./DetailData.vue?vue&type=script&lang=js"

import "./DetailData.vue?vue&type=style&index=0&id=be4a5f5c&scoped=true&lang=css"
import "./DetailData.vue?vue&type=style&index=1&id=be4a5f5c&lang=less&scoped=true"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be4a5f5c"]])

export default __exports__